import ApiService from '@/app/framework/services/ApiServices'
import { Endpoints } from '@/app/framework/misc/Endpoints'
import { injectable } from 'tsyringe'
import { UserReportRepositoryInterface } from '@/data/persistences/repositories/contracts/UserReportRepositoryInterface'
import { UserReport } from '@/domain/entities/UserReport'
import { UserReportDataMapper } from '@/data/persistences/mappers/UserReportDataMapper'

@injectable()
export class UserReportApiRepository implements UserReportRepositoryInterface {
  private service: ApiService
  private mapper: UserReportDataMapper

  constructor(service: ApiService, mapper: UserReportDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAll(params: Object): Promise<UserReport> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.REPORT_USER,
      params
    )
    return this.mapper.convertUserReportFromApi(resp)
  }
}
